import React from 'react';

const Requisites = () => {
    return (
        <div>
            
        </div>
    );
};

export default Requisites;